module.exports = __webpack_public_path__ + "static/student_reviews-605cb313dff025e722e490e92033fe7a.webm";